/**
 * Created by 芋道源码
 *
 * 枚举类
 */

/**
 * 支付渠道枚举
 */
export const PayChannelEnum = {
  WX_PUB: {
    "code": "wx_pub",
    "name": "微信 JSAPI 支付",
  },
  WX_LITE: {
    "code": "wx_lite",
    "name": "微信小程序支付"
  },
  WX_APP: {
    "code": "wx_app",
    "name": "微信 APP 支付"
  },
  ALIPAY_PC: {
    "code": "alipay_pc",
    "name": "支付宝 PC 网站支付"
  },
  ALIPAY_WAP: {
    "code": "alipay_wap",
    "name": "支付宝 WAP 网站支付"
  },
  ALIPAY_APP: {
    "code": "alipay_app",
    "name": "支付宝 APP 支付"
  },
  ALIPAY_QR: {
    "code": "alipay_qr",
    "name": "支付宝扫码支付"
  },
  ALIPAY_BAR: {
    "code": "alipay_bar",
    "name": "支付宝条码支付"
  },
}

/**
 * 支付的展示模式每局
 */
export const PayDisplayModeEnum = {
  URL: {
    "mode": "url",
  },
  IFRAME: {
    "mode": "iframe",
  },
  FORM: {
    "mode": "form"
  },
  QR_CODE: {
    "mode": "qr_code"
  }
}

/**
 * 支付类型枚举
 */
export const PayType = {
  WECHAT: "WECHAT",
  ALIPAY: "ALIPAY"
}

/**
 * 支付订单状态枚举
 */
export const PayOrderStatusEnum = {
  WAITING: {
    status: 0,
    name: '未支付'
  },
  SUCCESS: {
    status: 10,
    name: '已支付'
  },
  CLOSED: {
    status: 20,
    name: '支付关闭'
  }
}

/**
 * 支付订单回调状态枚举
 */
export const PayOrderNotifyStatusEnum = {
  NO: {
    status: 0,
    name: '未通知'
  },
  SUCCESS: {
    status: 10,
    name: '通知成功'
  },
  FAILURE: {
    status: 20,
    name: '通知失败'
  }
}

/**
 * 支付订单退款状态枚举
 */
export const PayOrderRefundStatusEnum = {
  NO: {
    status: 0,
    name: '未退款'
  },
  SOME: {
    status: 10,
    name: '部分退款'
  },
  ALL: {
    status: 20,
    name: '全部退款'
  }
}

/**
 * 支付退款订单状态枚举
 */
export const PayRefundStatusEnum = {
  CREATE: {
    status: 0,
    name: '退款订单生成'
  },
  SUCCESS: {
    status: 1,
    name: '退款成功'
  },
  FAILURE: {
    status: 2,
    name: '退款失败'
  },
  PROCESSING_NOTIFY: {
    status: 3,
    name: '退款中，渠道通知结果'
  },
  PROCESSING_QUERY: {
    status: 4,
    name: '退款中，系统查询结果'
  },
  UNKNOWN_RETRY: {
    status: 5,
    name: '状态未知，请重试'
  },
  UNKNOWN_QUERY: {
    status: 6,
    name: '状态未知，系统查询结果'
  },
  CLOSE: {
    status: 99,
    name: '退款关闭'
  }
}

// 会议模式常量
export const meetingModelEnum = [
  {
    id: 200,
    txt: "会议",
    value: "conference",
  },
  {
    id: 201,
    txt: "讲堂",
    value: "lecture",
  },
  // {
  //   id: 202,
  //   txt: "虚拟接待",
  //   value: "reception",
  // },
]

// 获取到会议模式
export function getModel(value){
  for(var i = 0; i < meetingModelEnum.length; i++){
    if(meetingModelEnum[i].value == value){
      return meetingModelEnum[i].txt
    }
  }
}


// 会议模式常量
export const timeZoneEnum = [
  {
    id: 100,
    txt: "（GMT+08:00）北京,上海,香港",
    value: "Asia/Shanghai",
    offset: 8 * 3600 * 1000
  },
  {
    id: 101,
    txt: "（GMT+09:00）东京,首尔",
    value: "Asia/Tokyo",
    offset: 9 * 3600 * 1000
  },
  {
    id: 102,
    txt: "（GMT+00:00）伦敦,法罗",
    value: "Europe/London",
    offset: 0
  },
  {
    id: 103,
    txt: "（GMT+01:00）巴黎,罗马",
    value: "Europe/Paris",
    offset: 1 * 3600 * 1000
  },
  {
    id: 104,
    txt: "（GMT+02:00）开罗,大马士革,雅典",
    value: "Europe/Athens",
    offset: 2 * 3600 * 1000
  },
  {
    id: 105,
    txt: "（GMT+03:00）卡塔尔,莫斯科",
    value: "Europe/Moscow",
    offset: 3 * 3600 * 1000
  },
  {
    id: 106,
    txt: "（GMT+04:00）亚美尼亚,毛里求斯",
    value: "Indian/Mauritius",
    offset: 4 * 3600 * 1000
  },
  {
    id: 107,
    txt: "（GMT+05:00）巴基斯坦,马尔代夫",
    value: "Asia/Karachi",
    offset: 5 * 3600 * 1000
  },
  {
    id: 108,
    txt: "（GMT+06:00）哈萨克斯坦,吉尔吉斯斯坦,孟加拉国",
    value: "Asia/Almaty",
    offset: 6 * 3600 * 1000
  },
  {
    id: 109,
    txt: "（GMT+07:00）泰国,越南,柬埔寨",
    value: "Asia/Bangkok",
    offset: 7 * 3600 * 1000
  },
  {
    id: 110,
    txt: "（GMT+10:00）澳大利亚",
    value: "Australia/Sydney",
    offset: 8 * 3600 * 1000
  },
  {
    id: 111,
    txt: "（GMT+11:00）托克劳,所罗门群岛",
    value: "Pacific/Guadalcanal",
    offset: 9 * 3600 * 1000
  },
  {
    id: 112,
    txt: "（GMT+12:00）斐济,瓦努阿图",
    value: "Pacific/Fiji",
    offset: 12 * 3600 * 1000
  },
  {
    id: 113,
    txt: "（GMT+13:00）汤加,萨摩亚",
    value: "Pacific/Apia",
    offset: 13 * 3600 * 1000
  },
  {
    id: 114,
    txt: "（GMT+14:00）基里巴斯,莱恩群岛",
    value: "Pacific/Kiritimati",
    offset: 14 * 3600 * 1000
  },
  {
    id: 115,
    txt: "（GMT-01:00）亚速尔群岛",
    value: "Atlantic/Azores",
    offset: -1 * 3600 * 1000
  },
  {
    id: 116,
    txt: "（GMT-02:00）南乔治亚岛",
    value: "Atlantic/South_Georgia",
    offset: -2 * 3600 * 1000
  },
  {
    id: 117,
    txt: "（GMT-03:00）巴西,阿根廷,乌拉圭",
    value: "America/Sao_Paulo",
    offset: -3 * 3600 * 1000
  },
  {
    id: 118,
    txt: "（GMT-04:00）波多黎各,加拿大",
    value: "America/Halifax",
    offset: -4 * 3600 * 1000
  },
  {
    id: 119,
    txt: "（GMT-05:00）美国纽约,多伦多,墨西哥城",
    value: "America/New_York",
    offset: -5 * 3600 * 1000
  },
  {
    id: 120,
    txt: "（GMT-06:00）美国芝加哥,尼加拉瓜",
    value: "America/Chicago",
    offset: -6 * 3600 * 1000
  },
  {
    id: 121,
    txt: "（GMT-07:00）美国丹佛",
    value: "America/Denver",
    offset: -7 * 3600 * 1000
  },
  {
    id: 122,
    txt: "（GMT-08:00）温哥华,美国洛杉矶",
    value: "America/Los_Angeles",
    offset: -8 * 3600 * 1000
  },
  {
    id: 123,
    txt: "（GMT-10:00）夏威夷州,萨摩亚",
    value: "Pacific/Honolulu",
    offset: -9 * 3600 * 1000
  },
  {
    id: 124,
    txt: "（GMT-11:00）美属萨摩亚",
    value: "Pacific/Pago_Pago",
    offset: -10 * 3600 * 1000
  },
]

// 当前浏览器时区  Asia/Shanghai
export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

// selectedTimezone 选择的时区  currentTime 当前时间  currentDate 当前日期
export function convertTimezone(selectedTimezone,currentTime) {
  const options = { timeZone: selectedTimezone,hour12: false};
  let year = currentTime.getFullYear()
  let month = currentTime.getMonth() + 1 >= 10 ? currentTime.getMonth() + 1 : "0" + ( currentTime.getMonth() + 1)
  let date = currentTime.getDate() >= 10 ? currentTime.getDate() : "0" + currentTime.getDate()
  return new Date( year + "-" + month + "-" + date + " " + currentTime.toLocaleTimeString('en-US', options));
}


export function getTimezoneTxt(value){
  for(var i = 0 ; i < timeZoneEnum.length; i++){
    if(timeZoneEnum[i].value === value){
      return timeZoneEnum[i].txt
    }
  }
}


// 充值金额常量
export const topMoneyEnum = [
    {
      id: "1",
      name: "50",
      price: "50",
    },
    {
      id: "2",
      name: "100",
      price: "100",
    },
    {
      id: "3",
      name: "200",
      price: "200",
    },
    {
      id: "4",
      name: "500",
      price: "500",
    },
]


// 充值金额常量
export const encryptionEnum = [
  {
    id: "201",
    txt: "无加密：所有H.323,SIP和MS-SIP与会者必须使用未加密的媒体",
    value: "50",
  },
  {
    id: "202",
    txt: "必须：所有与会者必须使用媒体加密",
    value: "100",
  },
  {
    id: "203",
    txt: "尽力：如果设备支持，每个与会者将使用媒体加密，否则连接将不加密",
    value: "200",
  },
]


export const helpTypeEnum = [
  {
    id: "101",
    txt: "故障申报",
  },
  {
    id: "102",
    txt: "技术支持",
  },
  {
    id: "103",
    txt: "意见反馈",
  },
  {
    id: "104",
    txt: "项目合作",
  },
  {
    id: "105",
    txt: "其他",
  },
]

export const accountUnlockEnum = [
  {
    id: "101",
    txt: "对不起,下不为例",
  },
  {
    id: "102",
    txt: "马上支付未款项",
  },
  {
    id: "103",
    txt: "多人使用导致，加强培训",
  },
  {
    id: "104",
    txt: "其他原因",
  },
]

export const SocialMediaEnum = [
  {
    id: "101",
    txt: "微信",
    value: "WeChat",
    image: "../../assets/img/icons/icon-wx.png"
  },
  {
    id: "102",
    txt: "微博",
    value: "Weibo",
    image: "../../assets/img/icons/icon-sina.png"
  },
  {
    id: "103",
    txt: "Youtube",
    value: "Youtube",
    image: "../../assets/img/icons/icon-youtube.png"
  },
  {
    id: "104",
    txt: "Facebook",
    value: "Facebook",
    image: "../../assets/img/icons/icon-facebook.png"
  },
  {
    id: "105",
    txt: "WhatsApp",
    value: "WhatsApp",
    image: "../../assets/img/icons/icon-whatsapp.png"
  },
  {
    id: "106",
    txt: "领英",
    value: "LinkedIn",
    image: "../../assets/img/icons/icon-linkedin.png"
  },
  {
    id: "107",
    txt: "ins",
    value: "Instagram",
    image: "../../assets/img/icons/icon-ins.png"
  },
  {
    id: "108",
    txt: "TikTok",
    value: "TikTok",
    image: "../../assets/img/icons/icon-tiktok.png"
  },
  {
    id: "109",
    txt: "LINE",
    value: "LINE",
    image: "../../assets/img/icons/icon-line.png"
  },
  {
    id: "110",
    txt: "Discord",
    value: "Discord",
    image: "../../assets/img/icons/icon-discord.png"
  },
]

